import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkoutTypeRuleCreateRequestDto } from '../../core/api/FitnessActivityClient';
import { injectTSDI } from '../../core/tsdi';
import { Api } from '../../core/api';
import { links } from '../../core/router';
import {
    toWorkoutValidationRulePayload,
    WorkoutValidationRuleForm,
    WorkoutValidationRuleFormData
} from './workout-validation-rule-form';

export const CreateWorkoutTypeRule: React.FC = () => {
    const navigate = useNavigate();
    const { fitnessActivityClient } = injectTSDI(Api);

    const handleSubmit = async (formData: WorkoutValidationRuleFormData) => {
        const requestData: WorkoutTypeRuleCreateRequestDto =
            toWorkoutValidationRulePayload(formData);

        await fitnessActivityClient.admin.workoutTypeRuleControllerCreate(
            requestData
        );

        navigate(links.workoutTypeRules());
    };

    return (
        <WorkoutValidationRuleForm
            title="Create Workout Validation Rule"
            submitLabel="Create"
            submittingLabel="Creating..."
            onCancel={() => navigate(links.workoutTypeRules())}
            onSubmit={handleSubmit}
        />
    );
};
